import React, { useState } from 'react';
import { Button } from 'react-bootstrap';

import usePrivileges from '../../../Auth/usePrivileges';
import { useGrades, useAlternativeGrades } from '../../../Utilities/useGrades';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsis } from '@fortawesome/free-solid-svg-icons';
import RegradeDialog from '../../../Dialogs/RegradeDialog';

export interface RegradeButtonProps {
    lotNumber: string,
    businessUnitCode: string,
    getLotDetail: () => void
}

function RegradeButton({ lotNumber, businessUnitCode, getLotDetail }: RegradeButtonProps) {

    const { canGrade } = usePrivileges(businessUnitCode);
    const [showRegradeDialog, setShowRegradeDialog] = useState(false);

    const { grades, loading: loadingGrades } = useGrades(businessUnitCode);
    const { alternativeGrades, loading: loadingAlternativeGrades } = useAlternativeGrades(lotNumber);

    return (
        <>
            <Button variant="light" className="ms-2"
                hidden={!canGrade}
                onClick={() => setShowRegradeDialog(true)}>
                <FontAwesomeIcon icon={faEllipsis} />
            </Button>
            <RegradeDialog
                showDialog={showRegradeDialog}
                closeDialog={() => setShowRegradeDialog(false)}
                lotNumber={lotNumber}
                getLotDetail={getLotDetail}
                alternativeGrades={alternativeGrades}
                grades={grades}
                loading={loadingAlternativeGrades || loadingGrades} />
        </>
    );
}

export default RegradeButton;